import axios from 'axios'

export default async function rollbackRichHtmlBlocks(id: number) {
  const { data } = await axios.post(
    `/api/v1/change-log/rollback/rich-html/${id}/`
  )

  return data
}
